import Model from '../BaseModel'
import Module from './Module'
import i18n from '@/plugins/i18n'

export default class Plan extends Model {
    resourceName() {
        return 'config-plans'
    }

    fields() {
        return ['id', 'external_id', 'partner', 'whitelabel', 'name']
    }

    relationships() {
        return {
            modules: new Module(),
        }
    }

    get formattedOriginalPrice() {
        return i18n.n(this.original_price, 'currency')
    }

    get formattedPartnerPrice() {
        return i18n.n(this.partner_price, 'currency')
    }

    get formattedWhitelabelPrice() {
        return i18n.n(this.whitelabel_price, 'currency')
    }

    get searchable() {
        return ['name']
    }

    get tableColumns() {
        return [
            { text: i18n.t('modules.index.table.headers.name'), value: 'name' },
            {
                text: i18n.t('resellers.types.partner'),
                value: 'partner',
                width: 300,
            },
            {
                text: i18n.t('resellers.types.whitelabel'),
                value: 'whitelabel',
                width: 300,
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                width: 150,
                align: 'end',
            },
        ]
    }
}
